<template>
  <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="620px" :close-on-click-modal="false" @close="handleClose">
    <el-form :model="formData" :rules="rules" ref="feeForm" label-width="120px">
      <el-form-item label="识别码" v-if="dialogType === 'batch'">
        <el-input :value="selectedData.map(item => item.oidNo).join(', ')" disabled></el-input>
      </el-form-item>

      <el-form-item label="识别码" v-if="dialogType === 'edit'">
        <el-input v-model="formData.oidNo" disabled></el-input>
      </el-form-item>
      <el-form-item label="台数" prop="eqpCount">
        <el-input v-model="formData.eqpCount" disabled></el-input>
      </el-form-item>
      <el-form-item label="原价" prop="testOtherFee">
        <el-input v-model="formData.testOtherFee" placeholder="请输入原价">
          <template slot="append">元</template>
        </el-input>
      </el-form-item>

      <el-form-item label="折扣" prop="feeDiscount">
        <el-input-number v-model="formData.feeDiscount" :min="0" :max="1" :step="0.01" :precision="4" controls-position="right" style="width: 100%" @change="onDiscountChange" />
      </el-form-item>

      <el-form-item label="折扣价">
        <el-input :value="discountedPriceDisplay" disabled placeholder="自动计算：原价×折扣">
          <template slot="append">元</template>
        </el-input>
      </el-form-item>

      <el-form-item label="操作员" prop="operator">
        <el-input v-model="formData.operator" disabled></el-input>
      </el-form-item>

      <el-form-item label="操作时间" prop="operateTime">
        <el-input v-model="formData.operateTime" disabled></el-input>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSave" :loading="saveLoading">保存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { saveOtherFee, updateOtherFee } from '@/api/contract/contract'

export default {
  name: 'OtherExpenseDialog',
  data () {
    const validateDiscount = (rule, value, callback) => {
      const n = Number(value)
      if (value === null || value === undefined || value === '') {
        callback(new Error('请输入折扣'))
        return
      }
      if (Number.isNaN(n) || n < 0 || n > 1) {
        callback(new Error('折扣必须在 0～1 之间'))
        return
      }
      callback()
    }
    return {
      dialogVisible: false,
      saveLoading: false,
      dialogType: 'batch',
      selectedData: [],
      formData: {
        oidNo: '',
        eqpCount: '',
        testOtherFee: '',
        feeDiscount: 1,
        operator: '',
        operateTime: ''
      },
      rules: {
        testOtherFee: [
          { required: true, message: '请输入原价', trigger: 'blur' },
          { pattern: /^[0-9]+(\.[0-9]{1,2})?$/, message: '请输入正确的金额格式', trigger: 'blur' }
        ],
        feeDiscount: [{ validator: validateDiscount, trigger: ['blur', 'change'] }]
      }
    }
  },
  computed: {
    dialogTitle () {
      return this.dialogType === 'batch' ? '批量录入其他检测费' : '修改其他检测费'
    },
    discountedPriceDisplay () {
      const p = parseFloat(this.formData.testOtherFee)
      const d = Number(this.formData.feeDiscount)
      if (this.formData.testOtherFee === '' || Number.isNaN(p) || Number.isNaN(d)) {
        return ''
      }
      return (Math.round(p * d * 100) / 100).toFixed(2)
    }
  },
  methods: {
    onDiscountChange (val) {
      if (val === undefined || val === null) {
        this.formData.feeDiscount = 1
      } else if (val < 0) {
        this.formData.feeDiscount = 0
      } else if (val > 1) {
        this.formData.feeDiscount = 1
      }
    },
    getRowTestDate (row) {
      return row.testEmployeeDate || row.testDate
    },
    openDialog (selectedRows, type) {
      const now = new Date()
      const currentYear = now.getFullYear()
      const currentMonth = now.getMonth() + 1

      const hasLastMonthData = selectedRows.some(row => {
        const raw = this.getRowTestDate(row)
        if (!raw) return false
        const testDate = new Date(raw)
        if (Number.isNaN(testDate.getTime())) return false
        const testYear = testDate.getFullYear()
        const testMonth = testDate.getMonth() + 1
        if (testYear < currentYear) return true
        if (testYear === currentYear && testMonth < currentMonth) return true
        return false
      })

      // if (hasLastMonthData) {
      //   this.$message.warning('所选数据中存在上个月的记录，不能录入')
      //   return
      // }

      this.dialogType = type
      this.selectedData = selectedRows
      this.dialogVisible = true

      // 台数：勾选了多少条就显示几
      this.formData.eqpCount = selectedRows.length

      if (type === 'edit' && selectedRows.length > 0) {
        const row = selectedRows[0]
        this.formData.oidNo = row.oidNo || ''
        const rawFee = row.testOtherFee !== undefined && row.testOtherFee !== null && row.testOtherFee !== ''
          ? row.testOtherFee
          : row.testCharge
        this.formData.testOtherFee =
          rawFee !== undefined && rawFee !== null && rawFee !== ''
            ? String(rawFee)
            : ''
        const cd = row.feeDiscount !== undefined && row.feeDiscount !== null && row.feeDiscount !== ''
          ? row.feeDiscount
          : row.custDiscount
        this.formData.feeDiscount =
          cd !== undefined && cd !== null && cd !== '' && !Number.isNaN(Number(cd))
            ? Number(cd)
            : 1
      } else {
        this.formData.testOtherFee = ''
        this.formData.feeDiscount = 1
      }

      this.formData.operator = this.$store.state.loginUser.userName || ''
      const today = new Date()
      const y = today.getFullYear()
      const m = String(today.getMonth() + 1).padStart(2, '0')
      const d = String(today.getDate()).padStart(2, '0')
      this.formData.operateTime = `${y}-${m}-${d}`
    },
    handleSave () {
      this.$refs.feeForm.validate((valid) => {
        if (!valid) {
          this.$message.warning('请填写完整信息！')
          return false
        }
        this.saveLoading = true
        if (this.dialogType === 'batch') {
          this.handleBatchSave()
        } else {
          this.handleUpdate()
        }
      })
    },
    handleBatchSave () {
      const feeDiscount = parseFloat(this.formData.feeDiscount)
      const testOtherFee = parseFloat(this.formData.testOtherFee)
      const saveDataList = this.selectedData.map(row => ({
        oidNo: row.oidNo,
        entrustNum: row.entrustNum,
        feeDiscount,
        testOtherFee
      }))
      saveOtherFee(saveDataList)
        .then(res => {
          this.saveLoading = false
          if (res.retCode === 'ok') {
            this.$message.success(res.retMsg || '保存成功')
            this.handleClose()
            this.$emit('refresh')
          } else {
            this.$message.error(res.retMsg || '保存失败')
          }
        })
        .catch(error => {
          this.saveLoading = false
          console.error('保存失败:', error)
          this.$message.error('保存失败')
        })
    },
    handleUpdate () {
      const row = this.selectedData[0]
      const id = row.id || row.feeId
      if (!id) {
        this.saveLoading = false
        this.$message.warning('缺少记录 id，无法修改')
        return
      }
      const updateData = {
        id,
        entrustNum: row.entrustNum,
        oidNo: row.oidNo,
        testOtherFee: parseFloat(this.formData.testOtherFee),
        feeDiscount: parseFloat(this.formData.feeDiscount)
      }
      updateOtherFee(updateData)
        .then(res => {
          this.saveLoading = false
          if (res.retCode === 'ok') {
            this.$message.success(res.retMsg || '修改成功')
            this.handleClose()
            this.$emit('refresh')
          } else {
            this.$message.error(res.retMsg || '修改失败')
          }
        })
        .catch(error => {
          this.saveLoading = false
          console.error('修改失败:', error)
          this.$message.error('修改失败')
        })
    },
    handleClose () {
      this.dialogVisible = false
      this.selectedData = []
      if (this.$refs.feeForm) {
        this.$refs.feeForm.resetFields()
      }
      this.formData = {
        oidNo: '',
        eqpCount: '',
        testOtherFee: '',
        feeDiscount: 1,
        operator: '',
        operateTime: ''
      }
    }
  }
}
</script>

<style scoped>
.dialog-footer {
  text-align: right;
}
</style>
